import styled from 'styled-components';
import { InputWrapper } from '../radio-button/styles';

export const Wrapper = styled.fieldset`
  display: ${({ $inline }) => ($inline ? 'flex' : 'block')};

  ${InputWrapper} {
    margin-right: ${({ $inline, theme }) => $inline && theme.spacing.medium};
  }
`;
